import React, { FC } from 'react';
import { User } from 'api/models';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { Value } from '../basics';
import { ContainedList } from './contained-list';
import { UserView } from './user-view';

export const UserListWithAvatar: FC<{
  users: User[];
}> = ({ users }) => {
  const {
    user: { userId: selfId },
  } = useUser();
  const youText = useTranslation('you');
  const items = users
    ?.sort((user) => (user?.userId === selfId ? -1 : 0))
    ?.map((user) =>
      user?.userId === selfId ? (
        <Value>{youText}</Value>
      ) : (
        <UserView key={user?.userId} user={user} />
      ),
    );

  return <ContainedList items={items} show={2} />;
};
